import { render, staticRenderFns } from "./StatusMandato.vue?vue&type=template&id=2d04c793&scoped=true&"
import script from "./StatusMandato.vue?vue&type=script&lang=js&"
export * from "./StatusMandato.vue?vue&type=script&lang=js&"
import style0 from "./StatusMandato.vue?vue&type=style&index=0&id=2d04c793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d04c793",
  null
  
)

export default component.exports